'use client'

import type { CurrentSectionLabelType } from '@types'

import useUpdatePreferences from '@hooks/user/useUpdatePreferences'
import Link from 'next/link'
import useLocale from '@hooks/client/useLocale'

type JobLinkProps = {
  url: string
  text: string
  label: CurrentSectionLabelType | null
}

export default function JobLink({ url, text, label }: JobLinkProps): JSX.Element {
  const updatePreferences = useUpdatePreferences()
  const country = useLocale()

  const targetUrl = url.startsWith('/us') || url.startsWith('/uk') ? url : `/${country}${url}`

  const submitSearch = (val: string): void => {
    if (label) {
      updatePreferences(undefined, label === 'MACRO' ? { macro: val } : { location_name: val })
    }
  }

  return (
    <Link key={url} href={targetUrl} onClick={(): void => submitSearch(text)} prefetch={false}>
      {text}
    </Link>
  )
}
